// src/Redux/languageSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  languages: [],
  isLoaded: false,
};

const languageSlice = createSlice({
  name: "languages",
  initialState,
  reducers: {
    setLanguages: (state, action) => {
      if (!state.isLoaded) {
        state.languages = action.payload;
        state.isLoaded = true; // lock after first set
      }
    },
  },
});

export const { setLanguages } = languageSlice.actions;

export default languageSlice.reducer;
